//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IPromotedPostsAudienceState } from 'app/promoted-posts/models/AppState';
import {
  PROMOTED_POSTS_AUDIENCE_ACTIONS,
  PromotedPostsAudienceTypes,
  PromotedPostsGenders,
} from 'app/promoted-posts/promoted-posts-constants/promoted-posts-audience-constants';

const initialState: IPromotedPostsAudienceState = {
  selectedAudience: PromotedPostsAudienceTypes.LOOKALIKE,
  lookalikeAudience: {
    audience: {
      name: null,
      id: null,
    },
  },
  // Defaults from Instragram's in-app experience
  customAudience: {
    availableLocations: [
      {
        label: 'United States',
        value: 'US',
      },
    ],
    location: {
      label: 'United States',
      value: 'US',
    },
    ageMin: 18,
    ageMax: 65,
    genders: [PromotedPostsGenders.FEMALE, PromotedPostsGenders.MALE],
  },
  accountAudiences: null,
  availableAudiences: null,
  availableAudienceOptions: [],
  isFetchingAudiences: false,
  audiencesExist: false,
};

export default function PromotedPostsAudienceReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.CLEAR_PROMOTED_POSTS_AUDIENCE_STATE:
      return initialState;
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.REQUEST_ACCOUNT_AUDIENCES:
      return {
        ...state,
        isFetchingAudiences: true,
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.RECEIVE_ACCOUNT_AUDIENCES:
      return {
        ...state,
        accountAudiences: {
          ...state.accountAudiences,
          [action.payload.accountId]: action.payload.availableAudiences,
        },
        availableAudiences: action.payload.availableAudiences,
        availableAudienceOptions: action.payload.availableAudiences.map(
          (audience: any) => ({ value: audience.id, label: audience.name }),
        ),
        lookalikeAudience: {
          audience: {
            id: action.payload.defaultLookalikeAudience.id,
            name: action.payload.defaultLookalikeAudience.name,
          },
        },
        audiencesExist: action.payload.audiencesExist,
        isFetchingAudiences: false,
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_SELECTED_AUDIENCE:
      return {
        ...state,
        selectedAudience: action.payload,
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_LOOKALIKE_AUDIENCE:
      return {
        ...state,
        lookalikeAudience: action.payload,
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_CUSTOM_AUDIENCE_AVAILABLE_LOCATIONS:
      return {
        ...state,
        customAudience: {
          ...state.customAudience,
          availableLocations: action.payload,
        },
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_CUSTOM_AUDIENCE_LOCATION:
      return {
        ...state,
        customAudience: {
          ...state.customAudience,
          location: action.payload,
        },
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_CUSTOM_AUDIENCE_AGE:
      return {
        ...state,
        customAudience: {
          ...state.customAudience,
          ageMin: action.payload.customAudienceAgeMin,
          ageMax: action.payload.customAudienceAgeMax,
        },
      };
    case PROMOTED_POSTS_AUDIENCE_ACTIONS.UPDATE_CUSTOM_AUDIENCE_GENDERS:
      return {
        ...state,
        customAudience: {
          ...state.customAudience,
          genders: action.payload,
        },
      };
    default:
      return state;
  }
}
